import React from "react";

function About() {
  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.mainTitle}>Contact</h1>

        {/* Contact Info */}
        <div style={styles.section}>
          <p><strong>Address:</strong> 273 Donald St, Ottawa, ON, Canada</p>
          <p><strong>Phone:</strong> (613) 600-1428</p>
          <p><strong>Email:</strong> masjidabother@gmail.com</p>
          <p><strong>Donation (e-Transfer):</strong> abuthermosque@gmail.com</p>
        </div>

        {/* Social Media */}
        <div style={styles.section}>
          <div style={styles.socialLinks}>
            {[
              { href: "https://www.facebook.com/AbuTharAlGhafariMosque?mibextid=ZbWKwL", icon: "/facebookLogo.png", label: "Facebook" },
              { href: "https://www.instagram.com/abotheralghafarimosque?igshid=MzNlNGNkZWQ4Mg%3D%3D", icon: "/InstagramLogo.png", label: "Instagram" },
              { href: "https://www.tiktok.com/@abotheralghafarim?_t=ZM-8szVHQuXbIT&_r=1", icon: "/tiktokLogo.png", label: "TikTok" },
              { href: "https://www.youtube.com/@abotheral-ghafarimosque3534", icon: "/youtubeLogo.png", label: "YouTube" },
              { href: "https://chat.whatsapp.com/FBCQzobDoWBFOpfDwEBQvV", icon: "/whatsappLogo.png", label: "WhatsApp" },
            ].map((link) => (
              <a
                key={link.label}
                href={link.href}
                target="_blank"
                rel="noreferrer"
                className="social-btn"
                style={styles.socialBtn}
              >
                <img src={link.icon} alt={link.label} style={styles.icon} />
                {link.label}
              </a>
            ))}
          </div>
        </div>

        {/* Google Maps */}
        <div style={styles.section}>
          <iframe
            title="Mosque Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2794.628509526304!2d-75.65286822345409!3d45.43021763681006!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4cce05f40ed5c39d%3A0x27284a4694cb69e8!2s273%20Donald%20St%2C%20Ottawa%2C%20ON%20K1K%201N1%2C%20Canada!5e0!3m2!1sen!2sca!4v1739999999999!5m2!1sen!2sca"
            width="100%"
            height="400"
            style={styles.map}
            allowFullScreen
            loading="lazy"
          ></iframe>
        </div>
      </div>

      {/* Hover Animation */}
      <style>{`
        .social-btn {
          transition: transform 0.25s ease, box-shadow 0.25s ease, background-color 0.25s ease;
        }
        .social-btn:hover {
          transform: scale(1.08);
          box-shadow: 0 6px 15px rgba(0,0,0,0.15);
          background-color: #f4f4f4;
        }
      `}</style>
    </div>
  );
}

const styles = {
  page: {
    backgroundColor: "#fff",
    fontFamily: "Georgia, serif",
    color: "#333",
    padding: "40px 15px",
    maxWidth: "1000px",
    margin: "0 auto",
    textAlign: "center",
  },
  card: {
    backgroundColor: "#f9f9f9",
    borderRadius: "20px",
    padding: "10px 30px 10px 30px",
    boxShadow: "0 6px 25px rgba(0, 0, 0, 0.1)",
  },
  mainTitle: {
    fontSize: "2.2rem",
    color: "#067446",
    fontWeight: "400",       // lighter weight
    letterSpacing: "0.5px",  // more spacing for elegance
    marginBottom: "40px",
  },
  section: {
    marginBottom: "40px",
    lineHeight: "1.8",
    fontSize: "1.05rem",
  },
  socialLinks: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "15px",
    marginTop: "10px",
  },
  socialBtn: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    textDecoration: "none",
    color: "#333",
    padding: "10px 18px",
    borderRadius: "10px",
    backgroundColor: "#fff",
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
    fontWeight: "500",
  },
  icon: {
    width: "22px",
    height: "22px",
  },
  map: {
    border: "0",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  },
};

export default About;
